
import React from 'react';

export default class PleaseStandBy extends React.Component {
	render() {
		// Get rid of background logo
		if (document.getElementById("apppage")) {
			document.getElementById("apppage").style.background = "transparent";
		}
		return (
			<div className="PleaseStandBy WINDOW_CENTEREDPART">
				<img alt="waiting" src="/images/wait.svg" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/PleaseStandBy.js